<template>
<span>
    <v-layout mb-4>
        <v-flex xs10 ml-3>
            <h2 class="lime--text lighten-1 pt-3">Gerenciar Cores - {{ product.prod_nome }}</h2>
        </v-flex>
        <v-flex xs2 mr-3 text-right>
            <v-btn color="blue-grey" class="black--text" :to="{name: 'products', params: {product_id: prod_id}}">
                <v-icon dark>keyboard_arrow_left</v-icon>
                Voltar
            </v-btn>
        </v-flex>
    </v-layout>

    <galeria-color-product v-on:atualiza="loadProductWithColors" :product="product"></galeria-color-product>

</span>
</template>

<script>
import GaleriaColorProductComponent from "./partial/GaleriaColorProductComponent";

export default {
    name: "AddColorProductComponent",
    created() {
        this.loadProductWithColors()
    },
    props: {
        prod_id: {
            require: true
        }
    },
    data() {
        return {
            product: {},
            cores: {},
            btnLabel: 'Salvar',
        }
    },
    methods: {
        loadProductWithColors() {
            this.$store.dispatch('loadProductWithColors', this.prod_id)
                .then(response => this.product = response)
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: 'Erro',
                        text: 'Dados não localizado',
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
        },
    },
    components: {
        GaleriaColorProduct: GaleriaColorProductComponent,
    }
};
</script>

<style scoped>

</style>
